import { ENV } from '@/lib/constants/environment';

type EnvUrlOptions = {
  prod: string;
  staging: string;
};

const DEFAULT_PORTAL_URLS: EnvUrlOptions = {
  staging: 'https://homolog-portal.redacaonota1000.com.br',
  prod: 'https://portal.redacaonota1000.com.br',
};

export const resolveEnvUrl = ({ prod, staging }: EnvUrlOptions): string => (ENV.PROD ? prod : staging);

export const resolvePortalUrl = (): string => resolveEnvUrl(DEFAULT_PORTAL_URLS);

export const resolvePath = (path: string): string => {
  const baseUrl = ENV.ANGULAR_PLATFORM_URL.replace(/\/+$/, '');
  const normalizedPath = path.replace(/^\/+/, '');
  return `${baseUrl}/${normalizedPath}`;
};
